<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";

export default {
  name: "CabinetMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin, unitConverterMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Object,
      required: true,
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return { };
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    /**
     * Loads the cabinet types
     *
     * @return {Array} - the array with the various cabinet types
     */
    typeOptions() {
      return this.$store.getters.optionLists_cabinetType;
    },

    fields() {
      return [
        {
          label: this.$i18n.tc("Cabinet", 1) + ' ' + this.$i18n.tc("Type", 1),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smcb_cabinet_type], this.typeOptions)
            : this.familySpecificFields.smcb_cabinet_type,
          varName: 'smcb_cabinet_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.typeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("Length") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smcb_length,
          varName: 'smcb_length',
          inputType: 'number',
          disabled: false,
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.t("Width") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smcb_width,
          varName: 'smcb_width',
          inputType: 'number',
          disabled: false,
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.t("Depth") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smcb_depth,
          varName: 'smcb_depth',
          inputType: 'number',
          disabled: false,
          step: '.01',
          min: '0',
        },
      ]
    },
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smcb_cabinet_type && this.familySpecificFields.smcb_cabinet_type.length > 0
      );
    },
  }
};
</script>

<style scoped>
.text-in-between {
  margin: 0 10px;
}

.specific-field-view-container {
  text-align: left;
  padding: 12px 0 7.5px 0;
}

.specific-field-view-container span {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 11.5px; /* 115% */
  text-transform: capitalize;
}

.specific-field-view-container span:last-child {
  font-weight: 700;
}

.specific-field-view-container:not(:last-child) {
  border-bottom: 1px solid #DBDBE0;
}

.specific-fields-view-container {
  width: 100%;
}

.card-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.card-info-item-container {
  display: flex;
  flex-direction: row;
  gap: 13px;
}

.card-info-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsCabinet.vue